import { render } from "./DeliveryCard.vue?vue&type=template&id=43ecae17"
import script from "./DeliveryCard.vue?vue&type=script&lang=js"
export * from "./DeliveryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__